import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import ButtonArrow from 'app/components/ButtonArrow'

import './styles.scss'

const baseClass = 'chart-slider'

const ChartSlider = ({ pending, page, count, limit, getActivitiesHistory, isFirstPage, isLastPage }) => (
  <div className={baseClass}>
    <ButtonArrow
      left
      buttonClass={`${baseClass}__arrow ${baseClass}__arrow--left`}
      disabled={pending || isFirstPage}
      onClick={() => getActivitiesHistory({ page: page - 1, limit })}
    />
    <div className={`${baseClass}__status-all`}>
      <div
        className={classNames(`${baseClass}__status-wrapper`, {
          [`${baseClass}__status-wrapper--pending`]: pending,
        })}
      >
        <div
          className={classNames(`${baseClass}__status-current`, {
            [`${baseClass}__status-current--pending`]: pending,
          })}
          style={{
            width: `${100 / (Math.floor(count / limit) + 1)}%`,
            transform: `translateX(${120 / (Math.floor(count / limit) + 1) * page}px)`,
          }}
        />
      </div>
    </div>
    <ButtonArrow
      right
      buttonClass={`${baseClass}__arrow ${baseClass}__arrow--right`}
      disabled={pending || isLastPage}
      onClick={() => getActivitiesHistory({ page: page + 1, limit })}
    />
  </div>
)

ChartSlider.propTypes = {
  pending: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  getActivitiesHistory: PropTypes.func.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  isLastPage: PropTypes.bool.isRequired,
}

export default ChartSlider
